import { FC } from 'react';
import { ReleaseAndDeployments } from '@agilelab/plugin-wb-builder-common';
import { Box } from '@material-ui/core';
import { PromoteToReleaseButton } from './PromoteToReleaseButton';
import { RowMenu } from './RowMenu';
import { UpdateButton } from './UpdateButton';

interface Props {
  release: ReleaseAndDeployments;
}

export const ReleaseActions: FC<Props> = ({ release }) => {
  const isSnapshot = release.metadata.isSnapshot;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      style={{ gap: 8 }}
    >
      {isSnapshot && (
        <>
          <PromoteToReleaseButton release={release} />
          <UpdateButton release={release} />
        </>
      )}
      <RowMenu release={release} />
    </Box>
  );
};
